export class Empty {
}
Empty.value = new Empty();
